import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './ContactPage.module.css';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
  };

  return (
    <>
      <Helmet>
        <title>Contact</title>
        <meta property="og:title" content="Contact" />
        <meta name="twitter:title" content="Contact" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* Header inner */}
      <section className={styles.headerSection}>
        <div className={styles.headerInner}>
          <div className={styles.headerLabel}>Contact</div>
          <h1 className={styles.headerTitle}>Have a question for us? Go for it.</h1>
          <p className={styles.headerDesc}>
            At sint tollit veritus duo, ex tota inimicus dissentiunt usu. Vix sonet nonumy contentiones et, alii pertinax at per.
          </p>
        </div>
      </section>

      {/* Contact section */}
      <section className={styles.contactSection}>
        <div className={styles.contactInner}>
          <h2 className={styles.contactH2}>
            Send us your enquiries. Eos in maluisset mediocritatem, option accusata ne sea.
          </h2>
          <div className={styles.contactGrid}>
            {/* Info bloc */}
            <div className={styles.contactInfo}>
              <div className={styles.contactInfoItem}>
                <strong>Email</strong>
                <p><a href="mailto:contact@spooncatering.com">contact@spooncatering.com</a></p>
              </div>
              <div className={styles.contactInfoItem}>
                <strong>Address</strong>
                <p>1263 Mission Street, Floor 3<br />San Francisco CA 94103<br />United States</p>
              </div>
            </div>

            {/* Formulaire */}
            <form className={styles.contactForm} onSubmit={handleSubmit}>
              <div className={styles.formField}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.formField}>
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.formField}>
                <label htmlFor="message">Tell us all about it</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your message..."
                  rows={6}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className={styles.submitBtn}>Submit</button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
